export const styles = {
    contentHeaderWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '32px',
    },
    contentBodyWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        boxShadow: ' 0 0 9px #9c9c9c61',
    },
    mx: (n) => ({
        mx: n,
    }),
    separatorLine: {
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: '#E1E3EA',
        borderBottomWidth: 'thin',
    },
};
